import clsx from 'clsx';
import format from 'date-fns/format';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import DataTable from 'components/CncUI/DataTable';

const useStyles = makeStyles(() => ({
  cellText: {
    textTransform: 'capitalize',
  },
  strikeThrough: {
    textDecoration: 'line-through',
  },
  italics: {
    fontStyle: 'italic',
    fontWeight: 600,
  },
  actorCell: {
    wordBreak: 'break-all',
  },
  header10: {
    width: '10%',
  },
  header13: {
    width: '13%',
  },
  header17: {
    width: '17%',
  },
  header30: {
    width: '30%',
  },
}));

const ActivityLogs = props => {
  const classes = useStyles();
  const { data } = props;

  const logs = data.map(entry => {
    return {
      ...entry,
      newAttributes: JSON.parse(entry.newAttributes),
      oldAttributes: JSON.parse(entry.oldAttributes),
    };
  });

  const renderAttributeCell = (oldOrNew, cellData, dataEntry) => {
    const keys = Object.keys(cellData);
    const filteredKeys = keys.filter(k => !['updatedAt', 'userId'].includes(k));

    const keyHasChanged = key => {
      const {
        newAttributes: { [key]: newValue } = {},
        oldAttributes: { [key]: oldValue } = {},
      } = dataEntry || {};
      if (newValue !== oldValue) return true;
      return false;
    };

    const valueClass = key => {
      if (keyHasChanged(key)) {
        return oldOrNew === 'old' ? classes.strikeThrough : classes.italics;
      }
      return '';
    };

    return (
      <Grid container spacing={0}>
        {filteredKeys.map(key => (
          <Grid item key={`${dataEntry.time}_${key}`} xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Typography size="short" variant="body1" medium>
                  {key}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  size="short"
                  variant="body1"
                  className={valueClass(key)}
                >
                  {cellData[key]}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    );
  };

  const columns = [
    {
      field: 'time',
      label: 'Timestamp',
      value: ({ time }) => format(parseInt(time, 10), 'MMM, do yyyy h:mm a'),
      cellProps: { className: classes.cellText },
      headerProps: { className: classes.header13 },
    },
    {
      field: 'actor',
      cellProps: { className: clsx(classes.cellText, classes.actorCell) },
      headerProps: { className: classes.header17 },
    },
    {
      field: 'action',
      cellProps: { className: classes.cellText },
      headerProps: { className: classes.header10 },
    },
    {
      field: 'oldAttributes',
      label: 'Old Attributes',
      value: row => renderAttributeCell('old', row.oldAttributes, row),
      cellProps: { className: classes.cellText },
      headerProps: { className: classes.header30 },
    },
    {
      field: 'newAttributes',
      label: 'New Attributes',
      value: row => renderAttributeCell('new', row.newAttributes, row),
      cellProps: { className: classes.cellText },
      headerProps: { className: classes.header30 },
    },
  ];

  return (
    <DataTable
      transparent
      columns={columns}
      data={logs || []}
      sort="time"
      order="desc"
      emptyRows="No activity logs"
    />
  );
};

export default ActivityLogs;
